import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RequestAudit from "@/pages/RequestAudit";

export const Route = createFileRoute("/en/request-your-audit")({
  head: () => buildRouteHead("/en/request-your-audit"),
  component: RequestAudit,
});

